import { CargaMasivaService } from "services";
import { ResponseExceptionHandlerHelper } from "utils";

export const CargaMasivaManager = (() => {
  const { handleException } = ResponseExceptionHandlerHelper();

  /**
   * Descarga la plantilla Excel de la entidad indicada.
   * Recibe la respuesta como Blob y dispara la descarga en el browser.
   */
  const descargarPlantilla = (entidad) => {
    return CargaMasivaService.descargarPlantilla(entidad).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res.blob;
    });
  };

  /**
   * Envía el archivo al servidor para su procesamiento.
   * Devuelve la lista de filas parseadas.
   */
  const procesarArchivo = (entidad, archivo) => {
    return CargaMasivaService.procesarArchivo(entidad, archivo).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res.Data;
    });
  };

  /**
   * Graba las filas en la base de datos.
   * Devuelve CargaMasivaResultadoDTO.
   */
  const guardar = (body) => {
    return CargaMasivaService.guardar(body).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res.Data;
    });
  };

  return {
    descargarPlantilla,
    procesarArchivo,
    guardar,
  };
})();
